import { Dialog } from 'primereact/dialog';

const AbiertasGanadasDialog = ({ visible, onHide }) => {
    
    return (
        <Dialog 
            header="Detalles Abiertas / Ganadas" 
            visible={visible} 
            className="p-fluid custom-dialog"
            onHide={onHide}
        >
            <div className="grid">
                <div className="col-12 md:col-6">
                    <div className="surface-0 p-3 border-round shadow-1 h-full">
                        <div className="text-xl font-bold mb-3">Abiertas</div>
                        <div className="text-4xl text-blue-500 font-bold">2</div>
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="surface-0 p-3 border-round shadow-1 h-full">
                        <div className="text-xl font-bold mb-3">Ganadas</div>
                        <div className="text-4xl text-green-500 font-bold">2</div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default AbiertasGanadasDialog;